import React, {PropTypes} from 'react';

class PreLoader extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.string
  };

  render() {
    if (this.props.loading === 'loading') {
      // Render loading gif
      return (
        <div className="spinner">
          <div className="cube1"/>
          <div className="cube2"/>
        </div>
      );
    }
    return null;
  }
}

export default PreLoader;



/** WEBPACK FOOTER **
 ** ./src/components/PreLoader.js
 **/